export default __webpack_public_path__ + "static/media/ifttt.1fad9021.png";